import { render, staticRenderFns } from "./ApplicantOtherIncome.vue?vue&type=template&id=72252e1c&scoped=true&"
import script from "./ApplicantOtherIncome.vue?vue&type=script&lang=js&"
export * from "./ApplicantOtherIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72252e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72252e1c')) {
      api.createRecord('72252e1c', component.options)
    } else {
      api.reload('72252e1c', component.options)
    }
    module.hot.accept("./ApplicantOtherIncome.vue?vue&type=template&id=72252e1c&scoped=true&", function () {
      api.rerender('72252e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantOtherIncome.vue"
export default component.exports